const ACCOUNT_LOGIN = '/login'
const RESET_PASS = '/login/reset'
const REFRESH_TOKEN = '/login/refreshtoken'

export const loginEndpoints = {
  ACCOUNT_LOGIN,
  RESET_PASS,
  REFRESH_TOKEN,
}
